// What `up-on-dismissed` would do, except that this application's CSP has no
// `unsafe-inline` for scripts. Unpoly rewrites an unverifiable callback attribute
// to `/* blocked */` and the layer then does nothing on close — silently, with
// nothing in the console. A compiler is ordinary pack JavaScript and is not
// affected, so the intent travels as data instead:
//
//   data-reload-on-overlay-close   re-read this region when an overlay opened
//                                  from inside it closes
//
// The device table is the case it was written for. A device's people and its files
// are edited on the device's own overlay, against their own endpoints, and each of
// them re-renders only a region inside that overlay — while the row behind it
// counts both. Saving the device is already right: the response renders the page
// under the overlay, and Unpoly peels the overlay off on the way. Cancelling,
// pressing Escape or clicking outside is what leaves the counts as they were when
// the overlay opened.
//
// The attribute may name an ancestor, and then an overlay opened anywhere inside
// that ancestor counts. The WLAN card lists who sends each SSID, and that is edited
// on the device overlay the table beside the card opens:
//
//   data-reload-on-overlay-close="#network-layout"
up.compiler('[data-reload-on-overlay-close]', (element) => {
  const scopeSelector = element.dataset.reloadOnOverlayClose
  const scope = (scopeSelector && element.closest(scopeSelector)) || element

  const onClosed = (event) => {
    // `:peel` is Unpoly closing an overlay because something rendered on a layer
    // below it — the save path. That render *is* the update, and reloading after it
    // would ask for the same page a second time.
    if (event.value === ':peel') return

    // Only an overlay this region itself opened. `layer.origin` is the element that
    // opened it, which for a row made followable with `up-expand` is the row rather
    // than the link inside it — both are in here, so containment answers where an
    // identity check would not.
    if (!event.layer.origin || !scope.contains(event.layer.origin)) return

    // Rejects when the region is gone from the response or the request fails.
    // Nothing is waiting on it, and an uncaught rejection would surface as a
    // console error in a scenario that has nothing to do with it.
    up.reload(element).catch(() => {})
  }

  document.addEventListener('up:layer:dismissed', onClosed)
  document.addEventListener('up:layer:accepted', onClosed)

  return () => {
    document.removeEventListener('up:layer:dismissed', onClosed)
    document.removeEventListener('up:layer:accepted', onClosed)
  }
})
